<ticketing-home></ticketing-home>
<ticketing-etiquetas-modal
  class="backModal enCierre"
  id="etiquetas"
  style="display:none"
></ticketing-etiquetas-modal>
<ticketing-calendar-etiquetas
  class="backModal enCalendar"
  id="datePickEtiquetas"
  style="display:none"
></ticketing-calendar-etiquetas>
<ticketing-calendar
  class="backModal enCalendar"
  id="datePick"
  style="display:none"
></ticketing-calendar>
<ticketing-calendar-home
  class="backModal enCalendar"
  id="datePickHome"
  style="display:none"
></ticketing-calendar-home>
<ticketing-date-picker
  class="backModal enCalendar"
  id="datePicker"
  style="display:none"
></ticketing-date-picker>
<ticketing-modal
  class="backModal"
  id="clientSearch"
  style="display:none"
></ticketing-modal>
<ticketing-impresion-modal
  class="backModal enCalendar"
  id="impresion"
  style="display:none"
></ticketing-impresion-modal>
<ticketing-gestionar-turno
  class="backModal enCalendar"
  id="gestionarTurno"
  style="display:none"
></ticketing-gestionar-turno>
<ticketing-cerrar-turno
  class="backModal"
  id="cerrarTurno"
  style="display:none"
></ticketing-cerrar-turno>
<ticketing-facturacion 
  class="backModal enCierre"
  id="facturar"
  style="display:none"
></ticketing-facturacion>
<ticketing-modal-contacto
  class="backModal enCierre"
  id="datoscontacto"
  style="display:none"
></ticketing-modal-contacto>
<ticketing-confirmar-cierre
  class="backModal enCalendar"
  id="confirmarCierreTurno"
  style="display:none"
></ticketing-confirmar-cierre>
<ticketing-confirmar-anulacion-venta
  class="backModal enCalendar"
  id="confirmarAnulacionVenta"
  style="display:none"
></ticketing-confirmar-anulacion-venta>
<ticketing-elevar-usuario
  class="backModal enCalendar"
  id="elevarUsuario"
  style="display:none"
></ticketing-elevar-usuario>
<ticketing-confirmar-entradas-localizador
  class="backModal enCalendar"
  id="confirmarEntradasLocalizador"
  style="display: none"
></ticketing-confirmar-entradas-localizador>
<ticketing-modal-datos-adicionales-entrada
  class="backModal enCierre"
  id="modalDatosAdicionalesEntrada"
  style="display: none"
></ticketing-modal-datos-adicionales-entrada>
<ticketing-impresion-localizador-modal
  class="backModal enCalendar"
  id="impresionLocalizador"
  style="display:none"
></ticketing-impresion-localizador-modal>
<ticketing-confirmar-reimpresion-dia-distinto
  class="backModal"
  id="confirmarReimpresionDiaDistinto"
  style="display: none"
></ticketing-confirmar-reimpresion-dia-distinto>
<ticketing-calendar-auditorio
  class="backModal enCalendar"
  id="datePickAuditorio"
  style="display:none"
></ticketing-calendar-auditorio>
<ticketing-confirmar-canjeo-caducado
  class="backModal enCalendar"
  id="confirmarCanjeoCaducado"
  style="display:none"
></ticketing-confirmar-canjeo-caducado>
<ticketing-confirmar-cambio-fecha
  class="backModal enCalendar"
  id="confirmarCambioFecha"
  style="display:none"
></ticketing-confirmar-cambio-fecha>
<ticketing-confirmar-venta-reserva-pagada
  class="backModal enCalendar"
  id="confirmarVentaReservaPagada"
  style="display:none"
></ticketing-confirmar-venta-reserva-pagada>
<ticketing-desglosar-cambio
  class="backModal"
  id="desglosarCambio"
  style="display:none"
></ticketing-desglosar-cambio>
<ticketing-codigo-auth
  class="backModal enCalendar"
  id="codigoAuth"
  style="display:none"
></ticketing-codigo-auth>
<ticketing-calcular-sinpe
  class="backModal"
  id="modalSinpe"
  style="display:none"
></ticketing-calcular-sinpe>
<ticketing-modal-simpe
  class="backModal enCierre"
  id="modalSimpe"
  style="display: none"
></ticketing-modal-simpe>
<ticketing-modal-motivos-devolucion
  class="backModal enCalendar"
  id="modal-motivos-devolucion"
  style="display: none"
></ticketing-modal-motivos-devolucion>
